import { Navigate } from 'react-router-dom';

export default function RegisterPage() {
  return <Navigate to="/auth" replace />;
}